<script setup lang="ts">
import { onMounted, nextTick } from 'vue'

onMounted(async () => {
    // DOMの更新を待ってから広告をリクエスト
    await nextTick()
    try {
        // @ts-expect-error adsbygoogle is added to window by external script
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
        console.error('ADSENSE_ERROR', e);
    }
})
</script>

<template>
    <div class="ad-banner-container">
        <div class="ad-wrapper">
            <!-- Google AdSense: デバイスごとに固定サイズを適用 -->
            <ins class="adsbygoogle main-ad-banner" style="display:inline-block"
                data-ad-client="ca-pub-5122036275013839" data-ad-slot="YOUR_AD_SLOT_HERE"></ins>
        </div>
    </div>
</template>

<style scoped>
.ad-banner-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
    padding: 0;
    min-height: 100px;
    /* モバイルの最小高さを確保 */
}

.ad-wrapper {
    background-color: #e0e0e0;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
}

/* --- デバイスごとの固定サイズ設定 --- */

/* デフォルト (モバイル): 320x100 */
.main-ad-banner {
    width: 320px;
    height: 100px;
}

/* タブレット / 小さめPC (600px以上): 728x90 */
@media(min-width: 600px) {
    .ad-banner-container {
        min-height: 90px;
    }

    .main-ad-banner {
        width: 728px;
        height: 90px;
    }
}

/* デスクトップ (1024px以上): 970x90 */
@media(min-width: 1024px) {
    .main-ad-banner {
        width: 970px;
        height: 90px;
    }
}
</style>
